var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.stories.length > 0
    ? _c(
        "section",
        {
          class: [
            "remove-margin",
            "global-search-stories",
            { "hide-result-content": _vm.hideByDefault }
          ]
        },
        [
          _vm._l(_vm.getFirstThreeStories, function(project, index) {
            return _c(
              "article",
              {
                key: index,
                staticClass: "global-search-single-story-container"
              },
              [
                _c("span", {
                  staticClass: "global-search-result-title",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.isTitleAndMatchTextCombined
                        ? project.referenceTitle
                        : _vm.markKeyWord(project.referenceTitle)
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.openProject(project)
                    }
                  }
                }),
                _vm.isTitleAndMatchTextCombined ||
                !project.referenceTitle
                  .toLowerCase()
                  .includes(
                    _vm.$store.getters
                      .getGlobalSearchResult("word")
                      .toLowerCase()
                  )
                  ? _c("p", {
                      staticClass: "global-search-result-text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.modifyText(
                            project.text !== undefined
                              ? project.text
                              : project.collection.join(", "),
                            100
                          )
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.openProject(project)
                        }
                      }
                    })
                  : _vm._e()
              ]
            )
          }),
          _vm.stories.length >= 2 && !_vm.hideShowAllButton
            ? _c(
                "button",
                {
                  staticClass: "show-all",
                  on: {
                    click: function($event) {
                      return _vm.viewAll()
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.$t("globalSearchSections.showAll")} (${
                          _vm.stories.length
                        })`
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }